import { useEffect } from 'react';

import { sum } from '@npi/buddy-utils';
import { useField } from 'formik';

import { Flex } from 'src/components/Flex';
import { RiskCard } from 'src/pages/AddMerchantPage/steps/SummaryInformation/components/RisksSection/components/RiskCard';

const CreditNoteTotals = () => {
    const [{ value: totalCreditNetAmount }, _, { setValue: setTotalCreditNetAmount }] =
        useField('totalCreditNetAmount');
    const [{ value: totalCreditVatAmount }, __, { setValue: setTotalCreditVatAmount }] =
        useField('totalCreditVatAmount');
    const [{ value: totalCreditAmount }, ____, { setValue: setCreditNoteTotalAmount }] =
        useField('totalCreditAmount');
    const [{ value: currencySymbol }, _____, { setValue: ________ }] = useField('currencySymbol');

    const [{ value: creditNoteItems }] = useField('creditNoteItems');

    useEffect(() => {
        const totalVatCents = sum(
            creditNoteItems.map(({ totalVat }) => {
                return totalVat;
            })
        );
        const totalNetCents = sum(
            creditNoteItems.map(({ totalNet }) => {
                return totalNet;
            })
        );
        const totalAmountCents = sum(
            creditNoteItems.map(({ lineTotal }) => {
                return lineTotal;
            })
        );

        setTotalCreditNetAmount(totalNetCents);
        setTotalCreditVatAmount(totalVatCents);
        setCreditNoteTotalAmount(totalAmountCents);
    }, [
        creditNoteItems,
        creditNoteItems.length,
        setCreditNoteTotalAmount,
        setTotalCreditNetAmount,
        setTotalCreditVatAmount,
    ]);

    return (
        <Flex gap="18px" flex={1}>
            <RiskCard
                label="Total Net Amount"
                value={totalCreditNetAmount}
                displayCurrencyValue={currencySymbol}
            />
            <RiskCard
                label="Total Vat Amount"
                value={totalCreditVatAmount}
                displayCurrencyValue={currencySymbol}
            />
            <RiskCard
                label="Total Credit Amount"
                value={totalCreditAmount}
                displayCurrencyValue={currencySymbol}
            />
        </Flex>
    );
};
export default CreditNoteTotals;
